"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventManager = exports._EventManager = void 0;
var Event_1 = require("./Event");
var Listener_1 = require("./Listener");
var _EventManager = /** @class */ (function () {
    function _EventManager() {
    }
    _EventManager.applyListen = function (fetchBy, persist, callback) {
        var listener = new Listener_1.Listener(fetchBy, persist, callback);
        this.listeners.push(listener);
        this.events.forEach(function (e) { return listener.matchEvent(e); });
        return listener;
    };
    _EventManager.publish = function (eventName, payload, persist) {
        var _this = this;
        if (persist === void 0) { persist = false; }
        var event = new Event_1.Event(eventName, payload);
        var hasListeners = this.listeners.filter(function (s, index) {
            if (s.matchEvent(event) && !s.persist) {
                _this.listeners.splice(index, 1);
            }
        });
        if (!hasListeners && !persist) {
            return null;
        }
        if (persist) {
            this.events.push(event);
        }
        return event.uid;
    };
    _EventManager.listen = function (fetchBy) {
        return this.applyListen(fetchBy, true).subject;
    };
    _EventManager.listenOnce = function (fetchBy, callback) {
        return this.applyListen(fetchBy, false, callback).uid;
    };
    _EventManager.removeAllListeners = function () {
        this.listeners = [];
        Listener_1.Listener.destroy();
    };
    _EventManager.removeAllEvents = function () {
        this.events = [];
        Event_1.Event.destroy();
    };
    _EventManager.removeListener = function (uid) {
        this.listeners = this.listeners.filter(function (e) { return e.uid !== uid; });
    };
    _EventManager.getListener = function (uid) {
        return this.listeners.find(function (e) { return e.uid === uid; });
    };
    _EventManager.countEvents = function () {
        return this.events.length;
    };
    _EventManager.countListeners = function () {
        return this.listeners.length;
    };
    _EventManager.removeEvent = function (uid) {
        this.events = this.events.filter(function (e) { return e.uid !== uid; });
    };
    _EventManager.listeners = [];
    _EventManager.events = [];
    return _EventManager;
}());
exports._EventManager = _EventManager;
var instance = window.__EVENT_MANAGER__ || (window.__EVENT_MANAGER__ = _EventManager);
exports.EventManager = instance;
